module.exports = __webpack_public_path__ + "static/media/email-top-senders.6c4d2d61.png";